import _ from 'lodash';
const ROOT_STYLES = getComputedStyle(document.documentElement);
const BREAK_SUFFIXES = ['xs', 'sm', 'md', 'ml', 'lg', 'xl', '2xl'];
const BREAK_BASE = 'md';
const BREAK_POINTS = Object.fromEntries(BREAK_SUFFIXES.map((suffix) => [suffix, parseInt(ROOT_STYLES.getPropertyValue(`--breakpoint-${suffix}`), 10) || 0]));
let current_device = window.innerWidth < BREAK_POINTS[BREAK_BASE] ? 'mobile' : 'pc';

const dispatchBreakPointEvent = (is_mobile: boolean) => {
  window.dispatchEvent(
    new CustomEvent('breakPoint', {
      detail: { is_mobile },
    }),
  );
};

const handleResize = _.debounce(() => {
  const is_mobile = window.innerWidth < BREAK_POINTS[BREAK_BASE];
  if ((is_mobile && current_device !== 'mobile') || (!is_mobile && current_device !== 'pc')) {
    current_device = is_mobile ? 'mobile' : 'pc';
    dispatchBreakPointEvent(is_mobile);
  }
});

const registerBreakPointEvent = () => {
  window.addEventListener('resize', handleResize);
};

export { registerBreakPointEvent };
